<template>
  <div class="meituan-physiotherapy-page">
    <div class="toolbar-wrap">
      <el-form class="search-form" :model="searchForm" inline size="small">
        <el-form-item label="美团商品ID">
          <el-input v-model="searchForm.condition.meituanGoodsId" clearable placeholder="请输入ID" />
        </el-form-item>
        <el-form-item label="理疗商品货号">
          <el-input v-model="searchForm.condition.physioArtNo" clearable placeholder="请输入货号" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.condition.status" clearable placeholder="请选择状态">
            <el-option label="全部" value="" />
            <el-option label="启用" value="0" />
            <el-option label="停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button class="consultation-fee-btn" type="primary" size="small" @click="openConsultationFeeDialog">编辑看诊费</el-button>
    </div>

    <el-table
      class="physio-table"
      :data="tableData"
      border
      height="360"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }"
    >
      <el-table-column prop="meituanGoodsId" label="美团商品ID" min-width="140" />
      <el-table-column prop="meituanGoodsName" label="美团商品名称" min-width="220" />
      <el-table-column prop="physioArtNo" label="理疗商品货号" min-width="150" />
      <el-table-column prop="physioName" label="理疗商品名称" min-width="220" />
      <el-table-column prop="status" label="状态" min-width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'">{{ scope.row.status == 0 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="执行提成" min-width="130">
        <template slot-scope="scope" v-if="scope.row.executeCommissionType">
          {{ scope.row.executeCommissionType === 1 ? `${scope.row.executeCommissionAmount}元` : `${scope.row.executeCommissionRate}%` }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-wrap">
      <el-pagination
        background
        layout="sizes,total, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize"
        :current-page="searchForm.pageIndex"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog title="编辑美团理疗扩展" :visible.sync="dialogVisible" width="560px">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="120px" size="small">
        <div class="goods-info">
          <div class="info-row">
            <span class="label">美团商品ID</span>
            <span>{{ editForm.meituanGoodsId }}</span>
          </div>
          <div class="info-row">
            <span class="label">美团商品名称</span>
            <span>{{ editForm.meituanGoodsName }}</span>
          </div>
          <div class="info-row">
            <span class="label">理疗商品货号</span>
            <span>{{ editForm.physioArtNo }}</span>
          </div>
          <div class="info-row">
            <span class="label">理疗商品名称</span>
            <span>{{ editForm.physioName }}</span>
          </div>
        </div>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="执行提成" prop="executeCommissionType">
              <el-radio-group v-model="editForm.executeCommissionType">
                <el-radio :label="1">固定金额</el-radio>
                <el-radio :label="2">固定比例</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="执行金额" prop="executeCommissionAmount" v-if="editForm.executeCommissionType == 1">
              <el-input v-model="editForm.executeCommissionAmount" placeholder="请输入金额">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="执行比例" prop="executeCommissionRate" v-if="editForm.executeCommissionType == 2">
              <el-input v-model="editForm.executeCommissionRate" placeholder="请输入比例">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑美团看诊费" :visible.sync="consultationFeeDialogVisible" width="420px">
      <el-form ref="consultationFeeForm" :model="consultationFeeForm" :rules="consultationFeeRules" label-width="90px" size="small">
        <el-form-item prop="registerFee">
          <span slot="label">
            看诊费
            <el-tooltip placement="top" effect="dark">
              <div slot="content">
                <div>仅针对普通门诊的美团订单发放看诊费（不含治疗师升单）</div>
                <div>同一天同一个患者同一个医生仅发放1次看诊费</div>
              </div>
              <i class="el-icon-question fee-tip"></i>
            </el-tooltip>
          </span>
          <el-input v-model="consultationFeeForm.registerFee" clearable placeholder="请输入金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="consultationFeeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveConsultationFee">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { salaryMeituanPhysioCommissionPage, getRegisterFee,saveRegisterFee,salaryMeituanPhysioCommissionDetail,salaryMeituanPhysioCommissionSave  } from '@/api/salary';
const getEmptyEditForm = () => ({
  meituanGoodsId: '',
  meituanGoodsName: '',
  physioArtNo: '',
  physioName: '',
  executeCommissionType: '',
  executeCommissionAmount: '',
  executeCommissionValue: ''
});

export default {
  name: 'MeituanPhysiotherapy',
  data() {
    return {
      total: 2,
      editIndex: -1,
      dialogVisible: false,
      consultationFeeDialogVisible: false,
      consultationFeeForm: {
        registerFee: ''
      },
      searchForm: {
        condition:{
          meituanGoodsId: '',
          physioArtNo:'',
          status:''
        },
        pageIndex: 1,
        pageSize: 10
      },
      editForm: getEmptyEditForm(),
      rules: {
        executeCommissionType: [{ required: true, message: '请选择执行提成方式', trigger: 'change' }],
        executeCommissionAmount: [{ required: true, message: '请输入执行金额', trigger: 'blur' }],
        executeCommissionRate: [
          { required: true, message: '请输入执行比例', trigger: 'blur' },
          { validator: this.validateRatio, trigger: 'blur' }
        ]
      },
      consultationFeeRules: {
        registerFee: [
          { required: true, message: '请输入看诊费', trigger: 'blur' },
          // 只能输入正整数
          { validator: (rule, value, callback) => {
            if(!/^\d+$/.test(value)) {
              callback(new Error('看诊费只能输入正整数'));
            } else if (value <= 0) {
              callback(new Error('看诊费不能小于0'));
            } else {
              callback();
            }
          }, trigger: 'blur' }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    //0-100的整数
    validateRatio(rule, value, callback) {
      if (value && !/^[0-9]\d*$/.test(value)) {
        callback(new Error('请输入0-100的整数'));
      } else {
        callback();
      }
    },
    async getTableData() {
      const {code,data} = await salaryMeituanPhysioCommissionPage(this.searchForm);
      if(code == 200){
        this.tableData = data.records;
        this.total = data.total;
      }
    },  
    handleSearch() {
      this.searchForm.pageIndex = 1;
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        condition: {
          meituanGoodsId: '',
          physioArtNo:'',
          status:''
        },
        pageIndex: 1,
        pageSize: 10
      };
      this.getTableData();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageIndex = 1;
      this.getTableData();
    },
    handleCurrentChange(pageIndex) {
      this.searchForm.pageIndex = pageIndex;
      this.getTableData();
    },
    openConsultationFeeDialog() {
      getRegisterFee().then(res => {
        if(res.code == 200){
          this.consultationFeeForm.registerFee = res.data || '';
          this.consultationFeeDialogVisible = true;
        }
      });
    },
    handleSaveConsultationFee() {
      this.$refs.consultationFeeForm.validate(valid => {
        if (!valid) return;
        saveRegisterFee(this.consultationFeeForm.registerFee).then(res => {
          if(res.code == 200){
            this.$message.success('保存成功');
            this.consultationFeeDialogVisible = false;
            this.getTableData();
          }
        });
      });
    },
    openEditDialog(row) {
      this.editIndex = this.tableData.indexOf(row);
      salaryMeituanPhysioCommissionDetail({meituanGoodsId: row.meituanGoodsId, physioArtNo: row.physioArtNo}).then(res => {
        if(res.code == 200){
          this.editForm = res.data;
          this.dialogVisible = true;
        }
      });
    },
    handleSave() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        salaryMeituanPhysioCommissionSave(this.editForm).then(res => {
          if(res.code == 200){
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.getTableData();
          }
        });
      });
    },
  }
};
</script>

<style lang="less" scoped>
.meituan-physiotherapy-page {
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #ffffff;

  .toolbar-wrap {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 0;

    /deep/ .el-form-item {
      margin-bottom: 12px;
    }
  }

  .consultation-fee-btn {
    flex: none;
  }

  .fee-tip {
    margin-left: 4px;
    color: #909399;
    cursor: pointer;
  }

  .physio-table {
    width: 100%;
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .goods-info {
    margin-bottom: 18px;
    padding: 12px 16px;
    background: #f7f8fa;
    border: 1px solid #ebeef5;

    .info-row {
      display: flex;
      line-height: 28px;
      color: #333333;

      .label {
        width: 110px;
        color: #606266;
      }
    }
  }

  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}
</style>